// import { ENDPOINT } from "services/configs/endpoint.constant";

import { HTTPMethod } from 'helpers/method';
import { ENDPOINT } from 'services/configs/endpoint.constant';

import {
  AddQuestionParams,
  AddQuestionResponse,
  DeleteConversationParams,
  EditConversationNamePayload,
  EditConversationNameResponse,
  EditQuestionParams,
  EditQuestionResponse,
  GetConversationsParams,
  GetConversationsResponse,
  GetDetailConversationParams,
  GetDetailConversationResponse,
  GetLatestMessageConversationParams,
  GetLatestMessageConversationResponse,
} from './conversation.type';
import { request } from '../configs/axiosConfig';

export const ConversationService = {
  getDetailConversation: async (params: GetDetailConversationParams) => {
    return request<GetDetailConversationResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_DETAIL_CONVERSATION,
      params,
    });
  },
  getLatestMessageConversation: async (params: GetLatestMessageConversationParams) => {
    return request<GetLatestMessageConversationResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_LATEST_MESSAGE_CONVERSATION,
      params,
    });
  },
  getConversations: async (params: GetConversationsParams) => {
    return request<GetConversationsResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_CONVERSATIONS,
      params,
    });
  },
  editConversationName: async (data: EditConversationNamePayload) => {
    return request<EditConversationNameResponse>({
      method: HTTPMethod.PUT,
      url: ENDPOINT.EDIT_CONVERSATION_NAME,
      data,
    });
  },
  deleteConversation: async (params: DeleteConversationParams) => {
    return request({ method: HTTPMethod.DELETE, url: ENDPOINT.DELETE_CONVERSATIONS, params });
  },
  addQuestion: async (params: AddQuestionParams) => {
    return request<AddQuestionResponse>({
      method: HTTPMethod.POST,
      url: ENDPOINT.ADD_QUESTION,
      params,
    });
  },
  editQuestion: async (params: EditQuestionParams) => {
    return request<EditQuestionResponse>({
      method: HTTPMethod.PUT,
      url: ENDPOINT.EDIT_QUESTION,
      params,
    });
  },
};
